/**
 *
 *  CalendarMonthGrid
 *  TruBe Date Time Calendar Month Grid Component
 *
 *  Created by Vladimir Shishlyannikov on 24/02/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React from "react";
import CalendarMonthScroller from "../CalendarMonthScroller/CalendarMonthScroller";

import { availabilityCalendar as calendarConstants } from "../../../constants";

const defaultProps = {
  enableOutsideDays: false,
  firstVisibleMonthIndex: 0,
  horizontalMonthPadding: 13,
  isAnimating: false,
  numberOfMonths: 3,
  modifiers: {},
  orientation: calendarConstants.CalendarOrientation.HORIZONTAL,
  onDayClick() {},
  onDayMouseEnter() {},
  onDayMouseLeave() {},
  onMonthChange() {},
  onYearChange() {},
  onMonthTransitionEnd() {},
  onMonthVisibleChange() {},
  renderMonthText: undefined,
  renderCalendarDay: undefined,
  translationValue: undefined,
  renderMonthElement: undefined,
  daySize: calendarConstants.DEFAULT_CALENDAR_DAY_SIZE,
  focusedDate: undefined,
  nextFocusedDate: undefined,
  isFocused: false,
  firstDayOfWeek: undefined,
  setMonthTitleHeight: undefined,
  isRTL: false,
  transitionDuration: 200,
  verticalBorderSpacing: undefined,
  dayAriaLabelFormat: undefined,
};

function getMonths(initialMonth, numberOfMonths, verticalScrollable) {
  let date = initialMonth.clone();

  const months_l = [];

  for (
    let t = 0;
    t < (verticalScrollable || true ? numberOfMonths : numberOfMonths + 2);
    t += 1
  ) {
    months_l.push(date);
    date = date.clone().add(1, "month");
  }

  return months_l;
}

export default class CalendarMonthGrid extends React.PureComponent {
  constructor(props) {
    super(props);

    this.container = null;
    this.isTransitionEndSupported = undefined;
    this.locale = undefined;
    this.removeEventListener = undefined;
    const verticalScrollable =
      props.orientation ===
      calendarConstants.CalendarOrientation.VERTICAL_SCROLLABLE;

    this.state = {
      months: getMonths(
        props.initialMonth,
        props.numberOfMonths,
        verticalScrollable
      ),
    };

    this.setContainerRef = this.setContainerRef.bind(this);
  }

  setContainerRef(ref) {
    this.container = ref;
  }

  render() {
    const {
      enableOutsideDays,
      modifiers,
      min,
      daySize,
      focusedDate,
      dayAriaLabelFormat,
      region,
      page,
      onDayMouseEnter,
      onDayMouseLeave,
      onDayClick,
      onMonthVisibleChange,
      onItemVisibleChange,
      onMonthTransitionEnd,
      renderCalendarDay,
    } = this.props;
    const { months } = this.state;
    const isMonthVisible = true;

    return (
      <div
        className={"calendar-month-grid"}
        ref={this.setContainerRef}
        onTransitionEnd={onMonthTransitionEnd}
      >
        <CalendarMonthScroller
          month={months[0]}
          months={months}
          page={page}
          min={min}
          enableOutsideDays={enableOutsideDays}
          modifiers={modifiers}
          onDayMouseEnter={onDayMouseEnter}
          onDayMouseLeave={onDayMouseLeave}
          onDayClick={onDayClick}
          onMonthVisibleChange={onMonthVisibleChange}
          onDayVisibleChange={onItemVisibleChange}
          renderCalendarDay={renderCalendarDay}
          daySize={daySize}
          region={region}
          focusedDate={isMonthVisible ? focusedDate : null}
          dayAriaLabelFormat={dayAriaLabelFormat}
        />
      </div>
    );
  }
}

CalendarMonthGrid.defaultProps = defaultProps;
